export default __webpack_public_path__ + "static/media/client-19.7a02caee.png";